export default "__VITE_ASSET__e075b911__"